import { Link, NavLink } from "react-router-dom";
import { ChevronRightIcon, cx } from "./ui";
import { tournamentPath } from "../lib/routes";
import type { Bundle, Division } from "../lib/types";

/**
 * Shared header for the public division pages: back-link to the tournament,
 * division title, and a segmented Schedule / Standings / Bracket control.
 */
export function DivisionPageHeader({ bundle, division }: { bundle: Bundle; division: Division }) {
  const tid = bundle.tournament.id;
  const base = `/t/${tid}/d/${division.id}`;
  const tabs = [
    { to: `${base}/schedule`, label: "Schedule" },
    { to: `${base}/standings`, label: "Standings" },
    { to: `${base}/bracket`, label: "Bracket" },
  ];

  return (
    <div className="animate-rise space-y-4">
      <Link
        to={tournamentPath(tid)}
        className="group inline-flex items-center gap-1 text-sm font-medium text-slate-500 transition-colors hover:text-brandText"
      >
        <ChevronRightIcon className="h-4 w-4 rotate-180 transition-transform duration-150 group-hover:-translate-x-0.5" />
        {bundle.tournament.name}
      </Link>
      <h1 className="font-display text-2xl font-bold tracking-tight text-navy-950 sm:text-3xl">
        {division.name}
      </h1>
      <nav className="flex w-full max-w-sm items-center gap-1 rounded-xl bg-slate-200/60 p-1">
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            className={({ isActive }) =>
              cx(
                "flex-1 rounded-lg px-3 py-1.5 text-center text-sm font-medium transition-all duration-200",
                isActive ? "bg-white text-navy-950 shadow-sm" : "text-slate-500 hover:text-slate-800",
              )
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
